
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Firstpage from "./Componanat/Firstpage.jsx";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default "/" se redirect */}
        <Route path="/" element={<Navigate to="/qrmovers" />} />

        {/* Movers page */}
        <Route path="/qrmovers" element={<Firstpage />} />
       

        
      </Routes>
    </BrowserRouter>
  );
}

export default App;